module.exports = __webpack_public_path__ + "static/img/starMemberBg2.0d8d742c.png";